import { memo } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { MapWorkOrder } from '@atom/types/map';

import { getGoogleShapeCenter } from '../mapUtilities';

import { getWorkOrderSvg } from './markerIconUtilities';
import {
  MARKER_STYLE,
  resolveAnchor,
  resolveOpacity,
  resolveZIndex,
} from './markerUtilities';

type WorkSingleMarkerProps = {
  workOrder: MapWorkOrder;
  isActive: boolean;
  disabled: boolean;
  onMarkerClick: (id: string, view: string) => void;
};

const WorkSingleMarker = ({
  workOrder,
  isActive,
  disabled,
  onMarkerClick,
}: WorkSingleMarkerProps) => {
  const position = getGoogleShapeCenter(workOrder.location);
  const svgUrl = getWorkOrderSvg(workOrder.statusId, isActive);

  return (
    <AdvancedMarker
      position={position}
      zIndex={resolveZIndex('workOrder', isActive)}
      {...resolveAnchor('workOrder', isActive)}
      style={{ ...MARKER_STYLE, opacity: resolveOpacity(disabled) }}
      onClick={() => onMarkerClick(workOrder.id, 'workOrder')}
    >
      <img src={svgUrl} alt="" />
    </AdvancedMarker>
  );
};

export default memo(WorkSingleMarker);
